import Stacks from 'components/stacks'
import { appliesMeta } from '@/utils/functions/applies-meta'

export default appliesMeta({
    requiresAuth: true,
    template: 'chameleon'
  },
  [
    {
      path: '/stacks',
      component: Stacks.Index,
      name: 'stacks.index',
    },
    {
      path: '/stacks/:stack_id',
      component: Stacks.Show,
      name: 'stacks.show',
      children: [
        {
          path: 'overview',
          component: Stacks.Overview,
            name: 'stacks.overview',
        },
        {
          path: 'invoices',
          component: Stacks.Invoices,
            name: 'stacks.invoices',
        },
        {
          path: 'aws-accounts',
          component: Stacks.AwsAccounts,
            name: 'stacks.aws-accounts',
        }
      ]
    },
  ])
